import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Indicatore di attesa: il logo compatto (`public/fametrue_compact.png`) che
 * compie un giro completo, si ferma un attimo, e riparte. L'animazione sta in
 * `.loader-logo` (app.css); con `prefers-reduced-motion` non ruota.
 *
 * `fullscreen` è la schermata di avvio prima che `/auth/me` risponda: fondo
 * navy come la login, per non avere un lampo di bianco. Senza, è il riquadro
 * neutro dei livelli in caricamento.
 */
export function Loader({ fullscreen = false }: { fullscreen?: boolean }): ReactNode {
  const { t } = useTranslation();

  return (
    <div className={fullscreen ? 'boot-screen' : 'level-placeholder'} role="status">
      <img
        className="loader-logo"
        src={`${import.meta.env.BASE_URL}fametrue_compact.png`}
        alt={t('app.loading')}
        width={64}
        height={64}
        draggable={false}
      />
    </div>
  );
}
